import React from "react";
import {HomeCity} from "mdi-material-ui";

export default function DepotDispersing(props) {
    return (
        <HomeCity className={props.className} />
    );
};